const MenuSupervisor = [
  {
    path: "dashboard",
    icon: "fa fa-th",
    title: "Dashboard",
    children: [
      { path: "dashboard/v2", title: "Dashboard Wappsolute" },
    ],
  },

	{
		path: "/user",
		icon: "fa fa-address-book text-yellow",
		title: "Users",
		badge: "10",
		children: [
			{ path: "/user/users/userroles", title: "Admin User-Roles" },
			{ path: "/user/users/userroles/new", title: "Add User-Role" },			
//			{ path: "/user/modulepermissions", title: "Admin Module-Permissions" },
			{ path: "/user/modulepermissions/new", title: "Add Module-Permission" },			
			{ path: "/user/users", title: "Users" },
			{ path: "/user/users/new", title: "Add User" },
			{ path: "/user/operators", title: "Operators" },	
 //     { path: "/crm/companies", title: "Companies" },	
      { path: "/user/supervisors", title: "Supervisors" },	
      { path: "/user/qeshsupervisors", title: "QESH Supervisors" },	    
      { path: "/user/qeshsofficers", title: "QESH Officers" },	    	    			
			{ path: "/user/search_user", title: "Search in Users" },
			{ path: "/clinic/contacts", title: "Contacts" }		
//			{ path: "/user/modulepermissions", title: "Admin Module-Permissions" },	
			
		],
	},

	{
    path: "/Human Resources",
    icon: "fa fa-graduation-cap text-gray",
    title: "Human Resources",
    badge: "10",
    children: [
      { path: "/user/skills", title: "Skills" },
      { path: "/planning/admincertificates", title: "Admin of Certifications" },	  
      { path: "/user/shifts", title: "Shifts" },
      { path: "/user/leaves", title: "Leaves" },
      { path: "/user/attendances", title: "Attendances" },
      { path: "/planning/adminskills", title: "Admin Skills" },
      { path: "/planning/admincertificates", title: "Admin Certificates" },	  
      { path: "/user/adminshifts", title: "Admin Shifts" },
      { path: "/user/leaves", title: "Leaves" },
      { path: "/planning/leavesreasons", title: "Admin Leave-Reasons" },	  
      { path: "/planning/adminskills", title: "Admin Skills" },	  	  
    ],
  },

  {
    path: "/AIML",
    icon: "far fa-brain text-gray",
    title: "AIML",
    children: [
	 { path: "/AIML/ImageAnnotations", title: "Settings" },    
      { path: "/AIML/chats", title: "chats" },
	 { path: "/AIML/ImageAnnotations", title: "Text Annotation" },	
	 { path: "/AIML/ImageAnnotations", title: "Videos Annotation" },
	 { path: "/AIML/ImageAnnotations", title: "Audios Annotation" },	    
         { path: "/AIML/ImageAnnotations", title: "Data Annotation" },	
         { path: "/AIML/ImageAnnotations", title: "Images Annotation" },
         { path: "/metai/yourdrive", title: "Data Training" },	    
         { path: "/AIML/APIs", title: "APIs" },	        	    
         { path: "/AIML", title: "AI Service Providers List" },
         { path: "/AIML", title: "AI Service Providers" },
         { path: "/AIML", title: "AIssistants" },	        
         { path: "/AIML", title: "AIML Tasks" },	  
         { path: "/drive/yourdrive", title: "Your Drive" },	    
         { path: "AIML/LabelStudio", title: "Label Studio" },
    ],
  },	

  {
    path: "/workinstructions", icon: "fa fa-briefcase text-teal", title: "Work Instructions",
    children: [
      { path: "/workinstructions/ALUInbound", title: "MN-NI-Inbound" },
      { path: "/workinstructions/ALUOutbound", title: "MN-NI-Outbound" },
      { path: "/workinstructions/ALUOutboundCheatSheet", title: "ALU-Outbound-CheatSheet" },				
      { path: "/workinstructions/RLC", title: "RLC" },
      { path: "/workinstructions/RLCGoodsReceive", title: "RLC Goods Receive" },	
	  { path: "/workinstructions/OTM", title: "OTM" },	
	  { path: "/workinstructions/password", title: "Password" },	
      { path: "/workinstructions/Shipment", title: "Shipment" },	
	  { path: "/workinstructions/VL09", title: "VL09" },
 	  { path: "/workinstructions/confirmationdeliveries", title: "Confirmation of Deliveries" },		
 	  { path: "/workinstructions/printerconfiguration", title: "PrinterConfiguration" },
      { path: "/workinstructions/OutboundGDC", title: "Outbound Nokia MN" },
      { path: "/workinstructions/workinstructions/new", title: "Add New WorkInstruction"},
      { path: "/workinstructions/workinstructions/", title: "Work Instructions List"},      				
//      { path: "/workinstructions/erinstructions/", title: "ER Instructions List" },
//      { path: "/workinstructions/erinstructions/new", title: "Add New ER Instruction" },
    ],
  },
	
  {
    path: "/QESH",
    icon: "fa fa-qesh-custom",
    title: "QESH",
    children: [
      { path: "/QESH/capas", title: "CAPAs" },
      { path: "/QESH/CAPAFormISO", title: "CAPAFormIso" },	    	    
    ],
  },	
	
  {
    path: "/label",
    icon: "fa fa-barcode text-cyan",
    title: "Barcode & Label",
    children: [
      { path: "/label/labels", title: "Labels" },
      { path: "/label/labels", title: "Input item" },

      { path: "/label/labelprint", title: "Print Label" },

//      { path: "/label/imageAnnotations", title: "Images Annotation" },	    
    ],
  },	
  {
    path: "/ERP",
    icon: "fa fa-ERP1-custom text-mint",
    title: "ERP",
    children: [
       { path: "/ERP/COOItems", title: "Input new Item by Camera" },	    
       { path: "/ERP/COOItems", title: "COOItems" },
       { path: "/ERP/COOitemsxls", title: "COO Items XLS" },	    	    
       { path: "/ERP/RVSs", title: "Repair Vendors Supplier List" },	 
      { path: "/ERP/outerboxbarcodeimages", title: "Outerbox codes" }
    ],
  },	
	
  {
    path: "/yourdrive",
    icon: "fa fa-cloud text-pink",
    title: "Yourdrive",
    children: [
      { path: "/yourdrive/yourdrive", title: "Your Drive" },
      { path: "/yourdrive/search_yourdrive", title: "Search in your drive" },
    ],
  },

  {
    path: "/Forum",
    icon: "fas fa-ticket-alt text-olive",
    title: "Forums",
    badge: "10",
    children: [ 
      { path: "/forum/forums", title: "Forums" },	   
    ],
  },

  {
    path: "/Ticket",
    icon: "fas fa-ticket-alt text-olive",
    title: "Tickets",
    badge: "10",
    children: [
      { path: "/ticket/tickets", title: "Tickets" },
      { path: "/ticket/tickets/new", title: "Add Ticket" },
      { path: "/ticket/ticketcategories", title: "Ticket Categories" },
      { path: "/ticket/ticketcategories/new", title: "Add Ticket Category" },
      { path: "/ticket/grid-tickets", title: "Gridview of Tickets" },
      { path: "/ticket/timelinetickets", title: "Timeline of Tickets" },
      { path: "/ticket/search_tickets", title: "Search in Tickets" },
      { path: "/ticket/ticketcategories", title: "Ticket-categories" },   
    ],
  },

  {
    path: "/Accounting",
    icon: "fas fa-balance-scale text-cyan",
    title: "Accounting",
    badge: "10",
    children: [
      { path: "/accounting/accountingsetting", title: "Setting" },	
      { path: "/accounting/invoices", title: "Invoices" },
      { path: "/accounting/invoices/new", title: "Add Invoice" },
      { path: "/accounting/expenses", title: "Expenses" },
      { path: "/accounting/expenses/new", title: "Add Expense" },
      { path: "/accounting/transactions", title: "Transactions" },
      { path: "/accounting/transactions/new", title: "Add transaction" },
      { path: "/accounting/COAs", title: "COAs" },
     { path: "/accounting/NCOAs", title: "COAs" },	  
      { path: "/accounting/COAs/new", title: "Add COA" },
      { path: "/accounting/services", title: "Services" },
      { path: "/accounting/services/new", title: "Add Service" },
      { path: "/accounting/products", title: "Products" },
      { path: "/accounting/products/new", title: "Add Product" },
      { path: "/accounting/profitlossstatement", title: "Profit vs Loss Statement"},
      { path: "/accounting/charts", title: "Charts" },
    ],
  },
	
]

export default MenuSupervisor;
